export const DEMO_SESSION_LIMIT = 3;
export const DEMO_SESSION_WINDOW_MS = 24 * 60 * 60 * 1000;
export const DEMO_SESSION_STORAGE_KEY = "ai_interview_demo_sessions";

export const getRecentDemoSessions = (
    storage: Pick<Storage, "getItem">,
    now = Date.now(),
): number[] => {
    try {
        const stored = JSON.parse(storage.getItem(DEMO_SESSION_STORAGE_KEY) || "[]");
        if (!Array.isArray(stored)) return [];

        return stored.filter(
            (value): value is number =>
                typeof value === "number" &&
                Number.isFinite(value) &&
                value > now - DEMO_SESSION_WINDOW_MS &&
                value <= now,
        );
    } catch {
        return [];
    }
};

export const getDemoSessionsRemaining = (
    storage: Pick<Storage, "getItem">,
    now = Date.now(),
) => Math.max(0, DEMO_SESSION_LIMIT - getRecentDemoSessions(storage, now).length);

export const recordDemoSession = (
    storage: Pick<Storage, "getItem" | "setItem">,
    now = Date.now(),
) => {
    try {
        const recentSessions = getRecentDemoSessions(storage, now);
        storage.setItem(
            DEMO_SESSION_STORAGE_KEY,
            JSON.stringify([...recentSessions, now]),
        );
        return true;
    } catch {
        return false;
    }
};
